import { ListenerMiddlewareInstance } from "@reduxjs/toolkit";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import { listenerMiddleware } from "../redux/listenerMiddleware";
import type { RootState, AppDispatch } from "../redux/store";

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
export const appListenerMiddleware: ListenerMiddlewareInstance<
  RootState,
  AppDispatch
> = listenerMiddleware as any;
